(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "../../fetch"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("../../fetch"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.fetch);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _default;

  function _default(data, url) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
    var fetch = method === 'post' ? _fetch.post : _fetch.get;
    return fetch(url, data, 'json').then(function (resp) {
      var code = resp.code,
          data = resp.data;
      return data;
    });
  }
});